import type { Tone } from "../schemas/blocks";

/**
 * Mapeia o `tone` (regra de negócio decidida no backend — RFC §3) para classes Tailwind.
 * O front NUNCA decide verde/vermelho; só traduz o tone recebido em cor.
 */

/** Cor do texto de uma célula/valor (coluna R$/m² do Figma). */
export function toneTextClass(tone?: Tone): string {
  switch (tone) {
    case "positive":
      return "text-success-700";
    case "negative":
      return "text-danger-700";
    default:
      return "";
  }
}

/** Classes da pill de badge (coluna Desvio do Figma). */
export function toneBadgeClass(tone?: Tone): string {
  switch (tone) {
    case "positive":
      return "bg-success-50 text-success-700 border border-success-200";
    case "negative":
      return "bg-danger-50 text-danger-700 border border-danger-200";
    default:
      return "bg-lightgray-200 text-darkgray-700 border border-lightgray-300";
  }
}
